"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NaturalPreserve = void 0;
const Tags_1 = require("../Tags");
const TileType_1 = require("../../TileType");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const SelectSpace_1 = require("../../inputs/SelectSpace");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
const AresHandler_1 = require("../../ares/AresHandler");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class NaturalPreserve extends Card_1.Card {
    constructor(name = CardName_1.CardName.NATURAL_PRESERVE, adjacencyBonus = undefined, metadata = {
        cardNumber: '044',
        renderData: CardRenderer_1.CardRenderer.builder((b) => {
            b.production((pb) => pb.megacredits(1)).nbsp().tile(TileType_1.TileType.NATURAL_PRESERVE, true).asterix();
        }),
        description: 'Oxygen must be 4% or less. Place this tile NEXT TO NO OTHER TILE. Increase your M€ production 1 step.',
        victoryPoints: 1,
    }) {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.BUILDING],
            cost: 9,
            productionBox: Units_1.Units.of({ megacredits: 1 }),
            adjacencyBonus,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oxygen(4).max()),
            metadata,
        });
    }
    static getAvailableSpaces(player) {
        const board = player.game.board;
        const spacesWithNoAdjacentTiles = board.getAvailableSpacesOnLand(player)
            .filter((space) => board.getAdjacentSpaces(space).some((adjacentSpace) => adjacentSpace.tile !== undefined) === false);
        if (player.game.gameOptions.aresExtension === true) {
            return spacesWithNoAdjacentTiles.filter((space) => AresHandler_1.AresHandler.canPayForTilePlacement(player, space));
        }
        return spacesWithNoAdjacentTiles;
    }
    canPlay(player) {
        return super.canPlay(player) && NaturalPreserve.getAvailableSpaces(player).length > 0;
    }
    play(player) {
        player.defer(new SelectSpace_1.SelectSpace('Select space for special tile next to no other tile', NaturalPreserve.getAvailableSpaces(player), TileType_1.TileType.NATURAL_PRESERVE, (foundSpace) => {
            player.game.addTile(player, foundSpace.spaceType, foundSpace, { tileType: TileType_1.TileType.NATURAL_PRESERVE });
            foundSpace.adjacency = this.adjacencyBonus;
            player.addProduction(Resources_1.Resources.MEGACREDITS, 1);
            return undefined;
        }), DeferredAction_1.Priority.PLACE_LAND_TILE);
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.NaturalPreserve = NaturalPreserve;
//# sourceMappingURL=NaturalPreserve.js.map